import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoPageSkeletonComponent } from '@tiltgroup/web-components';

@Component({
  selector: 'lig-unauthorized',
  standalone: true,
  imports: [CommonModule, InfoPageSkeletonComponent],
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnauthorizedComponent {}
